import DepotList from "./components/DepotList";

export default DepotList;